import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
import _ from 'lodash'; // ------------------------------

var state = function state() {
  return {
    recruit_api: '/api/recruits.json',
    recruit_list: []
  };
}; // ------------------------------


var getters = {
  recruitListAll: function recruitListAll(state) {
    try {
      // 大グループを分類
      var groupedByCareer = _.groupBy(state.recruit_list, function (item) {
        return item.career;
      }); // 中グループを分類


      var groupedByShop = _.mapValues(groupedByCareer, function (value) {
        return _.groupBy(value, function (item) {
          return item.shop;
        });
      });

      return groupedByShop;
    } catch (error) {
      return [];
    }
  }
}; // ------------------------------

var mutations = {
  setRecruitList: function setRecruitList(state, payload) {
    state.recruit_list = payload.recruits;
  }
}; // ------------------------------

var actions = {
  getRecruitList: function () {
    var _getRecruitList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, state, _ref2, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              _context.prev = 1;
              _context.next = 4;
              return axios.get(state.recruit_api);

            case 4:
              _ref2 = _context.sent;
              data = _ref2.data;
              commit('setRecruitList', data);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              console.error("Error! HTTP states: ".concat(_context.t0));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    function getRecruitList(_x) {
      return _getRecruitList.apply(this, arguments);
    }

    return getRecruitList;
  }()
}; // ------------------------------

export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};